import office1 from '../new_assets/Virtual_Background/Office/office1.jpg';
import office2 from '../new_assets/Virtual_Background/Office/office2.jpeg';
import office3 from '../new_assets/Virtual_Background/Office/office3.jpg';
import office4 from '../new_assets/Virtual_Background/Office/office4.jpeg';
import office5 from '../new_assets/Virtual_Background/Office/office5.jpeg';
import nature1 from '../new_assets/Virtual_Background/Nature/nature1.jpg';
import nature2 from '../new_assets/Virtual_Background/Nature/nature2.jpg';
import nature3 from '../new_assets/Virtual_Background/Nature/nature3.jpg';
import nature4 from '../new_assets/Virtual_Background/Nature/nature4.jpg';
import nature5 from '../new_assets/Virtual_Background/Nature/nature5.jpg';
import room1 from '../new_assets/Virtual_Background/Room/room1.jpg';
import room2 from '../new_assets/Virtual_Background/Room/room2.jpg';
import room3 from '../new_assets/Virtual_Background/Room/room3.jpg';
import room4 from '../new_assets/Virtual_Background/Room/room4.jpg';
import room5 from '../new_assets/Virtual_Background/Room/room5.jpg';

const visualEffectsPresets = [
  {
    id: 'no-effect',
    title: 'No Effects',
    items: [
      {
        id: 'none',
        label: 'No Effect',
        type: 'none',
        category: 'effect',
        badge: 'Off',
        description: 'Use your real background.',
        thumbnailStyle: {
          background: 'linear-gradient(140deg, rgba(12,17,28,0.85), rgba(34,43,60,0.95))',
          color: '#E2E8F0'
        }
      }
    ]
  },
  {
    id: 'blur',
    title: 'Blur',
    items: [
      {
        id: 'blur-normal',
        label: 'Normal Blur',
        type: 'blur',
        blurAmount: 'low',
        category: 'effect',
        badge: 'Normal',
        size: 'compact',
        hideLabel: true,
        thumbnailStyle: {
          background: 'radial-gradient(circle at 30% 30%, rgba(96, 165, 250, 0.65), rgba(30, 41, 59, 0.95))',
          color: '#E0F2FE'
        }
      },
      {
        id: 'blur-medium',
        label: 'Medium Blur',
        type: 'blur',
        blurAmount: 'medium',
        category: 'effect',
        badge: 'Medium',
        size: 'compact',
        hideLabel: true,
        thumbnailStyle: {
          background: 'radial-gradient(circle at 50% 50%, rgba(59,130,246,0.75), rgba(12,17,28,0.9))',
          color: '#DBEAFE'
        }
      },
      {
        id: 'blur-strong',
        label: 'High Blur',
        type: 'blur',
        blurAmount: 'high',
        category: 'effect',
        badge: 'High',
        size: 'compact',
        hideLabel: true,
        thumbnailStyle: {
          background: 'radial-gradient(circle at 70% 30%, rgba(29,78,216,0.9), rgba(15,23,42,0.95))',
          color: '#DBEAFE'
        }
      }
    ]
  },
  {
    id: 'office',
    title: 'Office',
    items: [
      {
        id: 'office-1',
        label: 'City Office',
        type: 'replacement',
        category: 'image',
        imageUrl: office1,
        thumbnailUrl: office1,
        hideLabel: true
      },
      {
        id: 'office-2',
        label: 'Creative Desk',
        type: 'replacement',
        category: 'image',
        imageUrl: office2,
        thumbnailUrl: office2,
        hideLabel: true
      },
      {
        id: 'office-3',
        label: 'Minimal Workspace',
        type: 'replacement',
        category: 'image',
        imageUrl: office3,
        thumbnailUrl: office3,
        hideLabel: true
      },
      {
        id: 'office-4',
        label: 'Bright Office',
        type: 'replacement',
        category: 'image',
        imageUrl: office4,
        thumbnailUrl: office4,
        hideLabel: true
      },
      {
        id: 'office-5',
        label: 'Modern Loft',
        type: 'replacement',
        category: 'image',
        imageUrl: office5,
        thumbnailUrl: office5,
        hideLabel: true
      }
    ]
  },
  {
    id: 'room',
    title: 'Room',
    items: [
      {
        id: 'room-1',
        label: 'Scandinavian Lounge',
        type: 'replacement',
        category: 'image',
        imageUrl: room1,
        thumbnailUrl: room1,
        hideLabel: true
      },
      {
        id: 'room-2',
        label: 'Cozy Living',
        type: 'replacement',
        category: 'image',
        imageUrl: room2,
        thumbnailUrl: room2,
        hideLabel: true
      },
      {
        id: 'room-3',
        label: 'Warm Studio',
        type: 'replacement',
        category: 'image',
        imageUrl: room3,
        thumbnailUrl: room3,
        hideLabel: true
      },
      {
        id: 'room-4',
        label: 'Artistic Corner',
        type: 'replacement',
        category: 'image',
        imageUrl: room4,
        thumbnailUrl: room4,
        hideLabel: true
      },
      {
        id: 'room-5',
        label: 'Sunlit Reading',
        type: 'replacement',
        category: 'image',
        imageUrl: room5,
        thumbnailUrl: room5,
        hideLabel: true
      }
    ]
  },
  {
    id: 'nature',
    title: 'Nature',
    items: [
      {
        id: 'nature-1',
        label: 'Ocean Retreat',
        type: 'replacement',
        category: 'image',
        imageUrl: nature1,
        thumbnailUrl: nature1,
        hideLabel: true
      },
      {
        id: 'nature-2',
        label: 'Green Valley',
        type: 'replacement',
        category: 'image',
        imageUrl: nature2,
        thumbnailUrl: nature2,
        hideLabel: true
      },
      {
        id: 'nature-3',
        label: 'Golden Bridge',
        type: 'replacement',
        category: 'image',
        imageUrl: nature3,
        thumbnailUrl: nature3,
        hideLabel: true
      },
      {
        id: 'nature-4',
        label: 'Forest Trail',
        type: 'replacement',
        category: 'image',
        imageUrl: nature4,
        thumbnailUrl: nature4,
        hideLabel: true
      },
      {
        id: 'nature-5',
        label: 'Desert Dusk',
        type: 'replacement',
        category: 'image',
        imageUrl: nature5,
        thumbnailUrl: nature5,
        hideLabel: true
      }
    ]
  }
];

export default visualEffectsPresets;

